import Game from 'app/records/game'
import React, { PropTypes } from 'react'
import Strings from 'config/strings'
import TeamGif from '../team-gif'
import ScoreBoard from '../score-board'
import { timerize, pluralize } from 'lib/strings'

export default React.createClass({

  propTypes: {
    game   : PropTypes.instanceOf(Game).isRequired,
    onNext : PropTypes.func.isRequired
  },

  render() {
    const { game, onNext } = this.props

    const current = Game.getCurrentTeam(game)
    const slot    = Game.getSlot(game)

    return (
      <main className={ "turn-in-progress fill-team-" + slot }>
        <div className="container">
          <div className="row">
            <div className="col turn-in-progress__time">
              <p>{ game.cards_left } { pluralize(game.cards_left, 'card', 'cards') } left</p>
              <p className="turn-in-progress__clock">{ timerize(60) }</p>
            </div>

            <ScoreBoard game={ game } className="col" />
          </div>

          <form className="turn-in-progress__card" ref="form" onSubmit={ this.onRoundStart }>

            <h2 className={ "turn-starting--desc " + "color-team-" + slot }>
              Team { current.name } is up
            </h2>

            <TeamGif team={ current } />

            <div className={ "turn-in-progress__rule " + "color-team-" + slot }>
              Round { game.round } • { Strings[`round.desc.${game.round }`] }
            </div>

            <footer className="text-align-center">
              <input className={ "turn-starting__submit " + " color-team-" + slot } type="submit" value="Start Turn" />
            </footer>
          </form>
        </div>
      </main>
    )
  },

  onRoundStart(e) {
    e.preventDefault()
    this.props.onNext()
  }
})



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/phases/turn-starting.jsx
 **/